import validate from "/Users/duncandeklerk/Dev/ProjectsVue/airabica/airabica-nuxtapp/node_modules/nuxt/dist/pages/runtime/validate.mjs";
export const globalMiddleware = [
  validate
]
export const namedMiddleware = {}